<span
  class="tvb-badge"
  [ngClass]=""
  [class]="styleClass"
  [ngStyle]="{ backgroundColor: backgroundColor, color: color, borderRadius: borderRadius, padding: padding }"
>
  {{ label }}
</span>
